module.exports = __webpack_public_path__ + "static/media/SDG5.5a47bba9.mp4";